import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  content
}: LegalModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm" data-id="element-161">
      <div className="bg-[#FBF8F3] w-full max-w-lg max-h-[80vh] rounded-lg shadow-2xl flex flex-col overflow-hidden animate-in fade-in zoom-in-95 duration-200" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-162">
        <div className="flex items-center justify-between p-4 border-b border-[#2C2C2C]/10" data-id="element-163">
          <h2 id="modal-title" className="text-xl font-serif font-semibold text-[#2C2C2C]" data-id="element-164">
            {title}
          </h2>
          <button onClick={onClose} className="p-1 rounded-full hover:bg-black/5 transition-colors text-[#2C2C2C]" aria-label="Close modal" data-id="element-165">
            <XIcon className="w-5 h-5" data-id="element-166" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto text-sm leading-snug text-[#2C2C2C]/80 font-sans" data-id="element-167">
          {content}
        </div>
      </div>
    </div>;
}